import { useQuery } from 'react-query';
import { axios } from '@/lib/axios';
import { useNotificationStore } from '@/stores/notifications';

export const getConnectedDefinitionsList = () => {
  return axios.get(`/api/v1/agent/metric`);
};

export const useGetConnectedDefinitionsList = ({ config }) => {
  const { addNotification } = useNotificationStore();

  const queryKey = ['getConnectedDefinitionsList'];

  return useQuery(queryKey, () => getConnectedDefinitionsList(), {
    // ...config,
    onError: (error) => {
      addNotification({ type: 'error', title: error.message });
    },
    ...config
  });
};
